import {convertToInt} from '@utils/helpers';
import {columnObjectAlignCenter, columnObjectAlignLeft} from '@utils/tableHelpers';

export const eventFields = {
    'event_id': {
        label: 'Event ID',
        sorting: (row) => convertToInt(row.event_id),
        ...columnObjectAlignCenter,
    },
    'match_id': {
        label: 'Match ID',
        sorting: (row) => row.match_id ? convertToInt(row.match_id) : null,
        ...columnObjectAlignCenter,
    },
};

export const productShortName = {
    'product_short_name': {
        label: 'Product',
        sorting: true,
        ...columnObjectAlignLeft,
    },
};

export const clientPackageName = {
    'client_package_name': {
        label: 'Package',
        sorting: true,
        ...columnObjectAlignLeft,
    },
};

export const geoFields = {
    'geo_restrictions_device': {
        label: 'Device categories',
        sorting: false,
        ...columnObjectAlignLeft,
        className: 'noPadding',
    },
    'geo_restrictions_country': {
        label: 'Countries',
        sorting: false,
        ...columnObjectAlignLeft,
        className: 'noPadding',
    },
    'geo_restrictions_country_count': {
        label: '#Countries',
        sorting: false,
        ...columnObjectAlignLeft,
        className: 'noPadding',
    },
};
